<template>

	<div class="images-slider">

		<div
			class="images-slider__control images-slider__control--prev"
			@click="movePlaysets('left')"
		>
			<i class="images-slider__icon images-slider__icon--prev"></i>
		</div>


		<div
			class="images-slider__control images-slider__control--next"
			@click="movePlaysets('right')"
		>
			<i class="images-slider__icon images-slider__icon--next"></i>
		</div>


		<Tweezing
			ref="tweezing"
			:to="Number(targetScrollHorizontal)"
			duration="200"
			@start="isScrolling = true"
			@end="isScrolling = false"
		>

			<div slot-scope="value">

				<div
					class="images-slider__inner-container"
					ref="imagesSlider"
					v-scroll-left="value"
					@scroll="setScrollTarget"
				>

					<div
						class="images-slider__inner"
						:style="{ width: (playsetItemWidth * playsets.length).toString() + 'px'}"
					>

						<playset-image
							class="images-slider__item"
							v-for="playset in playsets"
							v-show="!playset.selected"
							:key="playset.id"
							:price="playset.price.toFixed(0)"
							:image-url="playset.image"
							:draggable="playset.price < availableBudget"
							:id="playset.id"
						>
						</playset-image>

					</div>

				</div>

			</div>

		</Tweezing>

	</div>

</template>

<script>

import PlaysetImage from './playset-image';
import { scrollLeftMax } from '../../utils/scroll-helper.js';

// Tweezing
import Vue from 'vue'
import { Tweezing, tweezerHelper } from 'vue-tweezing'
import Tweezer from 'tweezer.js'

Vue.use(Tweezing, {
	tweezer: tweezerHelper(Tweezer)
})


export default {
	name: 'PlaysetImageSlider',
	components: {
		PlaysetImage,
	},
	directives: {
		scrollLeft: (element, binding) => {
			element.scrollLeft = binding.value;
		}
	},
	props: {
        playsets: {
            required: true
        },
        availableBudget: {
            type: Number,
            required: true
        }
    },
	data: () => ({
        targetScrollHorizontal: 0,
        isScrolling: false,
        scrollTimer: null,
		playsetItemWidth: 210,
	}),
	methods: {
		setSelected(selected) {

			const playsetIndex = this.playsets.findIndex(playset => playset.id == selected.id);

			this.$set(this.playsets, playsetIndex, Object.assign({}, this.playsets[playsetIndex], {
				position: selected.position,
				selected: true
			}));

		},
		setScrollTarget() {

            if(this.scrollTimer) {
                clearTimeout(this.scrollTimer);
            }

            // Do not set scroll target when scrolling with buttons
            // otherwise animation will stop and scroll ends before
            // the current scroll target
            if(this.isScrolling) return;

            this.scrollTimer = setTimeout(() => {
                // Set tweezing value and target to prevent tweezing from tweezing
                this.$refs.tweezing.value = this.$refs.imagesSlider.scrollLeft;
                this.targetScrollHorizontal = this.$refs.imagesSlider.scrollLeft;
                this.scrollTimer = null;
            }, 250);

		},
		movePlaysets(direction) {

			let moveDistance = this.playsetItemWidth;

			if (direction == 'left') {

				if(this.targetScrollHorizontal - moveDistance < 0) {
					this.targetScrollHorizontal = 0;
				} else {
					this.targetScrollHorizontal -= moveDistance;
				}

			} else if (direction == 'right') {

				if(this.targetScrollHorizontal + moveDistance > scrollLeftMax(this.$refs.imagesSlider)) {
					this.targetScrollHorizontal = scrollLeftMax(this.$refs.imagesSlider);
				} else {
					this.targetScrollHorizontal += moveDistance;
				}

			}
		}
	},
	mounted() {
		this.setScrollTarget();
	}
}

</script>

<style lang="scss" scoped>


.images-slider {

	/* Variables */
	$control-width: 40px;

	&__inner-container {
		position: relative;
    	margin-left: $control-width;
    	margin-right: $control-width;

		margin-top: 2px;
		margin-bottom: 20px;
		overflow-x: scroll;
		overflow-y: hidden;
		height: 250px;
		//background-color: #B0CFFB;
		background-color: #C6C8B3;
		padding: 20px 0px;
		user-select: none;

	}

	&__control {
		background-color: #6d6d6d;
		width: $control-width;
		height: 235px;
		opacity: 0.5;
		cursor: pointer;

		&--prev {
			float: left;
		}

		&--next {
			float: right;
		}
	}

	&__icon {
		border: solid #fff;
		border-width: 0 10px 10px 0;
		margin: auto;
		display: inline-block;
		padding: 10px;
		margin-top: 110px;

		&--prev {
			margin-left: 10px;
			transform: rotate(135deg);
			-webkit-transform: rotate(135deg);
		}

		&--next {

			transform: rotate(-45deg);
			-webkit-transform: rotate(-45deg);
		}
	}
}

</style>



// WEBPACK FOOTER //
// assets/vue/apps/participate/playset-image-slider.vue